(function () {
  const ACTIVE_CLASS = "is-active";
  const OPEN_CLASS = "is-open";

  // On lance la fonction initDropdown
  initDropdown();

  /**
   * Init dropdown
   */
  function initDropdown() {
    const dropdownList = document.querySelectorAll(".ux-dropdown");

    const closeOtherDropdowns = (currentDropdown) => {
      dropdownList.forEach((dropdown) => {
        if (dropdown !== currentDropdown && dropdown.classList.contains(ACTIVE_CLASS)) {
          closeDropdown(dropdown);
        }
      });
    };

    document.addEventListener("click", (e) => {
      if (!e.target.closest(".ux-dropdown")) {
        dropdownList.forEach((dropdown) => closeDropdown(dropdown));
      }
    });

    dropdownList.forEach((dropdown) => {
      const dropdownBtn = dropdown.querySelector(".ux-dropdown-button");
      const dropdownContent = dropdown.querySelector(".ux-dropdown-content");

      dropdownBtn.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();

        if (!dropdown.classList.contains(ACTIVE_CLASS)) {
          closeOtherDropdowns(dropdown);
        }

        handleDropdownButton(dropdown, dropdownBtn, dropdownContent);
      });

      window.addEventListener("scroll", () => closeDropdown(dropdown));
    });
  }

  /**
   * Handle dropdown button click
   *
   * @param {HTMLElement} dropdown - dropdown element type HTML
   * @param {HTMLElement} btn - dropdown button element
   * @param {HTMLElement} content - dropdown content element
   */
  function handleDropdownButton(dropdown, btn, content) {
    dropdown.classList.toggle(ACTIVE_CLASS);
    btn.classList.toggle(ACTIVE_CLASS);
    content.classList.toggle(OPEN_CLASS);
  }

  /**
   * Close dropdown
   *
   * @param {HTMLElement} dropdown - dropdown element type HTML
   */
  function closeDropdown(dropdown) {
    const dropdownBtn = dropdown.querySelector(".ux-dropdown-button");
    const dropdownContent = dropdown.querySelector(".ux-dropdown-content");

    dropdown.classList.remove(ACTIVE_CLASS);
    dropdownBtn.classList.remove(ACTIVE_CLASS);
    dropdownContent.classList.remove(OPEN_CLASS);
  }
})();
